import { Component, inject } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FiTimelineContentComponent } from '../timeline-content/timeline-content.component';
import { EventOutcomeModal } from '@app/features/appointments/components/event-outcome-modal/event-outcome-modal';
import { FutureEventCreationModalComponent } from '@app/features/sales/components/future-event-creation-modal/future-event-creation-modal.component';

@Component({
  templateUrl: './timeline-modal.component.html',
  standalone: true,
  imports: [FiTimelineContentComponent],
})
export class TimelineModalComponent {
  dialogConfig = inject(DynamicDialogConfig);
  dialogService = inject(DialogService);
  dialogRef = inject(DynamicDialogRef<TimelineModalComponent>);
  items = this.dialogConfig.data.items;
  projectId = this.dialogConfig.data.projectId;

  openFutureEventCreationModal() {
    const ref = this.dialogService.open(FutureEventCreationModalComponent, {
      header: 'Crea attività futura',
      width: '50%',
      data: {
        projectId: this.projectId,
      },
    });
    ref.onClose.subscribe(() => {
      // Chiude la timeline e permette al chiamante di reagire (es. refresh lista)
      this.dialogRef.close('future-event-created');
    });
  }

  openEventResultModal(eventId: string) {
    const ref = this.dialogService.open(EventOutcomeModal, {
      header: 'Esito',
      width: '50%',
      data: {
        eventId,
      },
    });
    ref.onClose.subscribe(() => {
      // Chiude la timeline per permettere l'aggiornamento dello stato esterno
      this.dialogRef.close('event-outcome-updated');
    });
  }
}
